import { useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { selectSearchResults } from '@client/myAccount/rma/redux/rmas/redux';
import { RmaSearchType } from 'b2b-common/core/account/api/rma';

export const useSearchRmasData = (): RemoteRecord<RmaSearchType> => useSelector(selectSearchResults);
